<div *ngIf="mobileTableViewData$ | async as data" [innerHtml]="data.view.answer"></div>
